var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.08325 13.9129V12.0796C2.08325 10.9963 2.96867 10.1004 4.06242 10.1004C5.94784 10.1004 6.71867 8.76708 5.77075 7.13167C5.22909 6.19417 5.552 4.97542 6.49992 4.43375L8.302 3.4025C9.12492 2.91292 10.1874 3.20458 10.677 4.0275L10.7916 4.22542C11.7291 5.86083 13.2708 5.86083 14.2187 4.22542L14.3333 4.0275C14.8228 3.20458 15.8853 2.91292 16.7083 3.4025L18.5103 4.43375C19.4583 4.97542 19.7812 6.19417 19.2395 7.13167C18.2916 8.76708 19.0624 10.1004 20.9478 10.1004C22.0312 10.1004 22.927 10.9858 22.927 12.0796V13.9129C22.927 14.9963 22.0416 15.8921 20.9478 15.8921C19.0624 15.8921 18.2916 17.2254 19.2395 18.8608C19.7812 19.8088 19.4583 21.0171 18.5103 21.5588L16.7083 22.59C15.8853 23.0796 14.8228 22.7879 14.3333 21.965L14.2187 21.7671C13.2812 20.1317 11.7395 20.1317 10.7916 21.7671L10.677 21.965C10.1874 22.7879 9.12492 23.0796 8.302 22.59L6.49992 21.5588C5.552 21.0171 5.22909 19.7983 5.77075 18.8608C6.71867 17.2254 5.94784 15.8921 4.06242 15.8921C2.96867 15.8921 2.08325 14.9963 2.08325 13.9129Z",
    fill: "#2E37A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 16.388C14.3696 16.388 15.8853 14.8723 15.8853 13.0026C15.8853 11.1329 14.3696 9.61719 12.4999 9.61719C10.6302 9.61719 9.1145 11.1329 9.1145 13.0026C9.1145 14.8723 10.6302 16.388 12.4999 16.388Z",
    fill: "#2E37A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon01);
export default __webpack_public_path__ + "static/media/setting-icon-01.924eba5cf28c84043f7defd44713d45b.svg";
export { ForwardRef as ReactComponent };